__turbopack_context__.v({
  "className": "neutrafacetext_bd3acd7d-module__I5fuCG__className",
  "variable": "neutrafacetext_bd3acd7d-module__I5fuCG__variable",
});
